import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';
import { Storage } from '@ionic/storage';
import { ActivatedRoute } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { Location } from '@angular/common';

import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';

@Component({
  selector: 'app-inscripcion',
  templateUrl: './inscripcion.page.html',
  styleUrls: ['./inscripcion.page.scss', '../../assets/scss/styles.scss'],
})
export class InscripcionPage implements OnInit {
  course: Course;
  courseid: string;

  constructor(
    public services:ServiceService,
    public storage: Storage,
    private activatedRoute: ActivatedRoute,
    public alertController: AlertController,
    private _location: Location,
    private firebaseAnalytics: FirebaseAnalytics
  ) { 
    this.firebaseAnalytics.logEvent;
    this.firebaseAnalytics.setCurrentScreen("Inscripción");
  }

  ngOnInit() {
    this.bringCoursesInformation();
  }

  backClicked() {
    this._location.back();
  }

  bringCoursesInformation(){
    this.courseid = this.activatedRoute.snapshot.paramMap.get('id');
    // console.log(this.courseid);
    
    this.services.coursesDetails(this.courseid).subscribe(data => {
        // console.log("data", data);
        this.course = data;
        // console.log("this.course", this.course);
      },
      error => {
        console.log(error);
      },
    );
  }

  /* doInscriptionBefore(){
    window.open(this.course?.url, '_system', 'location=yes');
    this.doInscription();
    return false;

    var ifrm = document.createElement('iframe');
    ifrm.setAttribute('id', 'ifrm'); // assign an id

    // to place before another page element
    var el = document.getElementById('iframeHolder');
    el.parentNode.insertBefore(ifrm, el);

    console.log(this.course?.url);
    
    // assign url
    ifrm.setAttribute('src', this.course?.url);
    ifrm.setAttribute('width', '0px');
    ifrm.setAttribute('height', '0px');
  } */

  doInscription(){
    this.services.inscription(this.courseid).subscribe(
      async (data:any) => {
        if(data?.string1){
          this.showAlert(data.string1);
          setTimeout(()=>{ window.open(this.course?.url, '_system', 'location=yes') },3000);
        }else{
          window.open(this.course?.url, '_system', 'location=yes');
        }
      },
      async error => {
        console.log(error);
      },
    );
  }

  async showAlert(message:string){
    const alert = await this.alertController.create({
      message: message
    });
    await alert.present();
  }
}

export class Course { 
 constructor(
  public id?: number,
  public name?: string,
  public level?: string,
  public schedule?: string,
  public modality?: string,
  public onlineDate?: string,
  public onlineTimeInit?: string,
  public onlineTimeEnd?: string,
  public presenceDate?: string,
  public presenceTimeInit?: string,
  public presenceTimeEnd?: string,
  public presencePlace?: string,
  public pattern?: string,
  public cost?: string,
  public totalHour?: string,
  public onlineHour?: string,
  public presenceHour?: string,
  public active?: string,
  public url?: string,
  public imageUrl?: string,
  public relUsersCourses?: RelUsersCourses,
 ) {}
}

export class RelUsersCourses { 
 constructor(
  public registered?: boolean,
 ) {}
}
